export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_materialNo') || '物料编号',
    field: 'materialNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('table_label_materialName') || '物料名称',
    field: 'materialName',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('table_label_materialSpec') || '物料规格',
    field: 'materialSpec',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('table_label_materialUnit') || '物料单位',
    field: 'materialUnit',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('table_label_ncMaterialNo') || 'NC物料编码',
    field: 'ncMaterialNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('table_label_quantity') || '订单数量',
    field: 'quantity',
    minWidth: 100,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 1,
        size: 'mini',
      },
    },
    formatter: ({ row }) => {
      const { quantity: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_actualQuantity') || '实收数量',
    field: 'actualQuantity',
    minWidth: 100,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 1,
        size: 'mini',
      },
    },
    formatter: ({ row }) => {
      const { actualQuantity: value } = row
      return that.format(value)
    },
  },
]
